(function($) {
    'use strict';

    $.fn.spoiler = function () {
        const $self = $(this);
        const $content = $self.find('.js-spoiler-content');
        const $toggle = $self.find('.js-spoiler-toggle');
        const threshold = 24;
        let resizeTimeout;

        const open = function () {
            $self.addClass('open');
            $content.css({
                'min-height': $content.get(0).scrollHeight
            });
        };

        const close = function () {
            $self.removeClass('open');
            $content.css({
                'min-height': function() {
                    let maxHeight = $content.css('max-height');
                    let contentHeight = $content.get(0).scrollHeight;

                    if (maxHeight === 'none') {
                        $toggle.removeClass('visually-hidden');
                        return 0;
                    } else if (contentHeight <= parseInt(maxHeight) + threshold) {
                        $toggle.addClass('visually-hidden');
                        return contentHeight;
                    } else {
                        $toggle.removeClass('visually-hidden');
                        return parseInt(maxHeight);
                    }
                }
            });
        };

        const refresh = function () {
            let maxHeight = parseInt($content.css('max-height'));
            let contentHeight = $content.get(0).scrollHeight;

            if ($self.hasClass('open')) {
                open();
            } else {
                close();
            }

            if (contentHeight <= maxHeight + threshold) {
                $content.addClass('no-spoiler');
            } else {
                $content.removeClass('no-spoiler');
            }
        };

        const init = function () {
            refresh();

            $toggle.on('click', function () {
                if ($self.hasClass('open')) {
                    close();
                } else {
                    open();
                }
            });

            $(window).on('resize', function () {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(refresh, 100);
            });
        };

        init();

        return this;
    };
})(jQuery);
